/* eslint-disable no-param-reassign */
import { combineReducers } from 'redux'

import createReducer from '../../../common/redux/createReducer'

const deliveryOccasions = createReducer(null, {
  FETCH_DELIVERYOCCASIONS_SUCCESS: (state, action) => action.payload
})

const sesamRequests = createReducer([], {
  FETCH_SESAMREQUESTS_SUCCESS: (state, action) => action.payload,
})

const sesamLockDescriptions = createReducer(
  {},
  {
    FETCH_SESAMREQUESTS_SUCCESS: (state, action) => {
      action.payload.forEach((val) => {
        if (!state[val.public_id]) state[val.public_id] = val
      })
    },
  }
)

const sesamThread = createReducer(
  {},
  {
    FETCH_SESAMTHREAD_SUCCESS: (state, action) => action.payload,
  }
)

const sesamThreads = createReducer([], {
  FETCH_SESAMTHREADS_SUCCESS: (state, action) => action.payload.sort((a, b) => b.latestEvent - a.latestEvent),
})

export default combineReducers({
  deliveryOccasions,
  sesamRequests,
  sesamLockDescriptions,
  sesamThread,
  sesamThreads,
})
